import React, { useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Popover } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import * as ROUTES from '../../routes';
import SwitcherList from './SwitcherList';
import { connect } from 'react-redux';
import SwitcherModal from './SwitcherModal';
import {
  decryptPassword,
  doSignInWithEmailAndPassword,
} from '../../configs/environments/firebase/firebaseApp';
import { loginUser, logoutUser, changeToCourtesyLawyer } from '../../store/actions/UserAction';
import { showLoading, hideLoading } from '../../store/actions/LoadingActions';
import './LoginSwitcher.scss';

const maleAvatar = '/img/avatars/avatares-cuadro-h.svg';
const femaleAvatar = '/img/avatars/avatares-cuadro-m.svg';
const lawFirmAvatar = '/img/avatars/avatares-cuadro-logo.svg';

const useStyles = makeStyles({
  paper: {
    left: 65,
  },
});

const LoginSwitcher = ({
  officeName,
  role,
  genero,
  membershipType,
  loginUser,
  logoutUser,
  showLoading,
  hideLoading,
  credentialsLawyer,
  imgProfile,
  idLawFirm,
  name,
  firstLastName,
  secondLastName,
  expanded,
  changeToCourtesyLawyer,
}) => {
  let defaultAvatar;
  if (role === 'lawFirm') {
    defaultAvatar = lawFirmAvatar;
  } else if (role === 'lawyer' && genero === 'male') {
    defaultAvatar = maleAvatar;
  } else {
    defaultAvatar = femaleAvatar;
  }

  const classes = useStyles();
  const history = useHistory()
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    if (
      idLawFirm ||
      (credentialsLawyer &&
        credentialsLawyer.email &&
        credentialsLawyer.password)
    ) {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'switcher-list' : undefined;

  const [formikModal, setFormikModal] = useState(false);

  const handleChangeFormikModal = () => {
    setFormikModal(!formikModal);
  };

  const [selectedElemInDrop, setSelectedElemInDrop] = useState(
    role === 'lawFirm' ? 1 : 0
  );
  const [switchState, setSwitchState] = useState({
    open: false,
    switchTo: '',
  });

  const handleCloseSwitcher = () => {
    setAnchorEl(null);
    setSwitchState({
      ...switchState,
      open: !switchState,
    });
    setSelectedElemInDrop (role === 'lawFirm' ? 1 : 0)
  };

  const changeToLawfirm = async (values) => {
    
    try {
      showLoading();
      await logoutUser();
      await loginUser(values.email, values.password, 'lawyeruser');
      hideLoading();
    } catch (error) {
      hideLoading();
      console.log('error', error);
    }
  };

  const changeToLawyer = async () => {
    try {
      showLoading();
      const data = await decryptPassword({
        email: credentialsLawyer.email,
        password: credentialsLawyer.password,
      });
      const { email, password } = data;
      await logoutUser();
      // ESTA FUNCIÓN SE LLAMA EN VEZ DEL LOGIN PORQUE EL ABOGADO
      // QUE LE PERTENECE A UN DESPACHO NO PUEDE HACER LOGIN DIRECTO EN EL PORTAL
      const userResponse = await doSignInWithEmailAndPassword(email, password);
      changeToCourtesyLawyer(userResponse)
      hideLoading();
    } catch (error) {
      hideLoading();
      console.log('error', error);
    }
  };

  const handleListItemClick = async (event, index) => {
    if (index === 0 && selectedElemInDrop !== 0) {
      setSwitchState({
        open: true,
        switchTo: 'lawyer',
      });
      setSelectedElemInDrop(index);
      setAnchorEl(null);
    } else if (index === 1 && selectedElemInDrop !== 1) {
      setSwitchState({
        open: true,
        switchTo: 'lawfirm',
      });
      setSelectedElemInDrop(index);
      handleChangeFormikModal()
    }
  };

  return (
    <div className="loginSwitcher">
      {membershipType === 'Premium' ?
        <div className='loginSwitcher_premiumBadge'/> : null
      }
      <div className={`loginSwitcher_container${!expanded ? 'Contracted' : ''}`}>
        {expanded ?
        <p className='loginSwitcher_title'>
          {role === 'lawFirm'
            ? membershipType === 'Free'
              ? 'Despacho Free'
              : membershipType === 'Premium'
              ? 'Despacho Premium' : ''
            : role === 'lawyer'
            ? membershipType === 'Free'
              ? 'Abogado Free'
              : membershipType === 'Premium'
              ? 'Abogado Premium' : ''
            : ''}
        </p> :
        <p className='loginSwitcher_titleContracted'>
          {role === 'lawFirm'
            ? membershipType === 'Free'
              ? 'Free'
              : membershipType === 'Premium'
              ? 'Premium' : ''
            : role === 'lawyer'
            ? membershipType === 'Free'
              ? 'Free'
              : membershipType === 'Premium'
              ? 'Premium' : ''
            : ''}
        </p>
        }
        <div
          className={
            idLawFirm ||
            (credentialsLawyer &&
              credentialsLawyer.email &&
              credentialsLawyer.password)
              ? `loginSwitcher_containerAvatar${!expanded ? 'Contracted' : ''}`
              : `loginSwitcher_containerAvatarDisabled${!expanded ? 'Contracted' : ''}`
          }
          onClick={handleClick}
        >
          <img
            className={
              membershipType === 'Premium' ?
                'loginSwitcher_avatarPremium' :
                'loginSwitcher_avatarFree'
            }
            src={imgProfile ? imgProfile : defaultAvatar}
            alt="avatar"
          />
          {expanded ?
            <p className="loginSwitcher_name">
              {role === 'lawFirm'
                ? `${officeName}`
                : role === 'lawyer'
                ? `${name} ${firstLastName} ${secondLastName}`
                : ''}
            </p> : null
          }
          {(expanded && idLawFirm) ||
            (expanded &&
            credentialsLawyer &&
            credentialsLawyer.email &&
            credentialsLawyer.password) ? (
            <>
              {open ? (
                <img src="/img/switcher-login/drop-up.svg" alt="arrow" />
              ) : (
                <img src="/img/switcher-login/drop-down.svg" alt="arrow" />
              )}
            </>
          ) : null}
        </div>
      </div>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        classes={{ root: classes.paper }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <SwitcherList
          selectedIndex={selectedElemInDrop}
          handleListItemClick={handleListItemClick}
        />
      </Popover>
      <SwitcherModal
        open={switchState.open}
        handleClose={handleCloseSwitcher}
        primaryFunction={
          switchState.switchTo === 'lawyer' ? changeToLawyer : changeToLawfirm
        }
        setSelectedElemInDrop={setSelectedElemInDrop}
        switchTo={switchState.switchTo}
        fromLogin
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  officeName: state.authClient.officeName,
  role: state.authClient.role,
  genero: state.authClient.genero,
  membershipType: state.authClient.membership.type,
  credentialsLawyer: state.authClient.credentialsLawyer,
  imgProfile: state.authClient.imgProfile,
  idLawFirm: state.authClient.idLawFirm,
  name: state.authClient.name,
  firstLastName: state.authClient.firstLastName,
  secondLastName: state.authClient.secondLastName,
});

const mapDispatchToProps = (dispatch) => ({
  loginUser: (email, password, roleAuth) => dispatch(loginUser(email, password, roleAuth)),
  changeToCourtesyLawyer: user => dispatch(changeToCourtesyLawyer(user)),
  logoutUser: () => dispatch(logoutUser()),
  showLoading: () => dispatch(showLoading()),
  hideLoading: () => dispatch(hideLoading()),
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginSwitcher);
